export var TestStatus;
(function (TestStatus) {
    TestStatus["PENDING"] = "PENDING";
    TestStatus["PASS"] = "PASS";
    TestStatus["FAIL"] = "FAIL";
    TestStatus["SKIPPED"] = "SKIPPED";
})(TestStatus || (TestStatus = {}));
//# sourceMappingURL=TestStatus.js.map